interface Props {
  color?: string
  width?: number
  height?: number
}

export const TopAlignIcon = ({ color = '#6F6F6F', width = 21, height = 21 }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.3164 4.4209C14.5922 4.42129 14.8164 4.64502 14.8164 4.9209V20.3945C14.8164 20.6704 14.5922 20.8941 14.3164 20.8945H6.5791C6.30296 20.8945 6.0791 20.6707 6.0791 20.3945V4.9209C6.07913 4.64478 6.30298 4.4209 6.5791 4.4209H14.3164ZM7.0791 19.8945H13.8164V5.4209H7.0791V19.8945ZM20.3945 0C20.6706 5.55377e-05 20.8945 0.223892 20.8945 0.5C20.8945 0.776061 20.6706 0.999944 20.3945 1H0.5C0.223892 1 5.55538e-05 0.776095 0 0.5C0 0.223858 0.223858 0 0.5 0H20.3945Z"
        fill={color}
      />
    </svg>
  )
}
